import React, { Component } from 'react'

import NavAnchor from '../../components/partials/NavAnchor';
import Breadcrumb from '../../components/Breadcrumb';
import AdaptHeightBanner from '../../components/partials/banner/AdaptHeightBanner';
import PanelTable from '../../components/panelContent/PanelTable';
import SectionCollapseInfo from '../../components/partials/collapse/SectionCollapseInfo';
import NavContentTab2 from '../../components/partials/NavContentTab2';
import SectionFaq from '../../components/partials/collapse/SectionFaq';
import SectionAd3 from '../../components/partials/SectionAd3';
import Panel from '../../components/panel/Panel';
import PanelTab from '../../components/panelContent/PanelTab';
import { Grid } from '@material-ui/core';
import Button from '../../components/Button';
import PanelInformation from '../../components/panelContent/PanelInformation';
import Link from '../../components/Link';
import * as Mock from '../../mock/AddValue.js';
class Program extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    changeMainTab = value => {
        this.setState({
            currentMainTab: value,
        });
        return value === 0 ? this.props.history.push('/cbu/5g') : null
    };
    render() {
        return (
            <main className="prepaid ribbon-bg-wrapper">
                
                <Breadcrumb
                    breadcrumb={[
                        { text: '首頁', link: '/' },
                        { text: '預付卡', link: '/' },
                        { text: '計量型上網方案說明', link: '/' },
                    ]}
                    color='white'
                />
                <AdaptHeightBanner
                    height={{
                        desktop: 360,
                        mobile: 180
                    }}
                    bgImg={{
                        md: '/resources/cbu/prepaid/images/cbu-prepaid-banner-1920x360.jpg',
                        sm: '/resources/cbu/prepaid/images/cbu-prepaid-banner-750x360.jpg',
                    }}
                    title='計日型上網方案說明' />
                <Panel className="is-bg-lightgray70">
                    <div className="fui-container">
                        <h2>計日型上網方案</h2>
                        <div className='paper mb-5'>
                            <h4 className="mt-3 is-text-medium mb-3">方案總覽</h4>
                            <p>計日型上網皆為吃到飽方案，60GB以內不降速，盡情享受無線上網的權利！</p>
                            <PanelTable
                                content={`<div class="compareTable content-16 clearfix">
                                    <div class="tableLeft">
                                        <div class="tableHead">
                                            <table>
                                                <tbody>
                                                    <tr style="height: 52px;">
                                                        <th></th>
                                                    </tr>
                                                    <tr style="height: 52px;">
                                                        <th>基本網路流量</th>
                                                    </tr>
                                                    <tr style="height: 52px;">
                                                        <th>網路速度</th>
                                                    </tr>
                                                    <tr style="height: 52px;">
                                                        <th>使用期限</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tableRight">
                                        <div class="tableBody">
                                            <div class="spaceBox">
                                                <table class="compareList">
                                                    <tbody>
                                                        <tr style="height: 52px;">
                                                            <td>5天上網</td>
                                                            <td>3天上網</td>
                                                            <td>1天上網</td>
                                                            <td>30天上網</td>
                                                        </tr>
                                                        <tr style="height: 52px;">
                                                            <td colspan="4">吃到飽</td>
                                                        </tr>
                                                        <tr style="height: 52px;">
                                                            <td>不降速</td>
                                                            <td>不降速</td>
                                                            <td>不降速</td>
                                                            <td>60GB後降速至5Mbps以下</td>
                                                        </tr>
                                                        <tr style="height: 52px;">
                                                            <td>連續24小時</td>
                                                            <td>連續72小時</td>
                                                            <td>連續120小時</td>
                                                            <td>連續720小時</td>
                                                        </tr>
                                                    </tbody>
                                                </table> 
                                            </div>
                                        </div>
                                    </div>
                                </div>`
                                }
                            />
                        </div>
                        <Link to={'#'} className='fui-button is-text pr-0 mb-5'>
                            <i className='icon-chevron-left mr-1'></i>
                            <span>回到預付卡儲值</span>
                        </Link>
                    </div>
                </Panel>
                <SectionAd3 {...{
                    patternColor: 'green',
                    title: `透過遠傳官網儲值，立即享有網路限定優惠`,
                    action: [{
                        text: '立即儲值',
                        line: '#',
                    }]
                }} />
                <div className="fui-container">
                    <PanelInformation title={'備註事項'} content={'備註事項'} />
                </div>
            </main>
        );
    }
}
export default Program;